const SectionLabel = ({ label, count }: { label: string; count: number }) => (
  <div className="mb-3 flex items-center gap-2">
    <span className="text-xs font-semibold uppercase tracking-wider text-gray-500">{label}</span>
    <span className="inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-gray-100 px-1.5 text-[11px] font-semibold leading-none text-gray-500">
      {count}
    </span>
  </div>
);

export default SectionLabel;
